import { IChatMessageSent } from '@sdk/contracts';
import { create } from 'zustand';

type LocalMessage = IChatMessageSent & { clientId?: string; pending?: boolean };

interface IStore {
  chats: Record<string, LocalMessage[]>;
  saveLocalChatMessage: (chatId: string, message: LocalMessage) => void;
  removeLocalChatMessage: (chatId: string, idOrClientId: string) => void;
}

export const useLocalChats = create<IStore>(set => ({
  chats: {},
  saveLocalChatMessage: (chatId, message) => {
    set(state => {
      const messages = state.chats[chatId] || [];

      const idxByClientId = message.clientId
        ? messages.findIndex(m => m.clientId === message.clientId)
        : -1;

      if (idxByClientId !== -1) {
        const next = [...messages];
        next[idxByClientId] = { ...messages[idxByClientId], ...message, pending: false };
        return { chats: { ...state.chats, [chatId]: next } };
      }

      const idxById = messages.findIndex(m => m._id === message._id);
      if (idxById !== -1) {
        const next = [...messages];
        next[idxById] = { ...messages[idxById], ...message, pending: false };
        return { chats: { ...state.chats, [chatId]: next } };
      }

      return { chats: { ...state.chats, [chatId]: [...messages, message] } };
    });
  },
  removeLocalChatMessage: (chatId, idOrClientId) => {
    set(state => {
      const messages = state.chats[chatId] || [];
      const filtered = messages.filter(m => m._id !== idOrClientId && m.clientId !== idOrClientId);
      return { chats: { ...state.chats, [chatId]: filtered } };
    });
  }
}));
